import ApiService from '@/api/service/ApiService.js';  
const uuidv1 = require('uuid/v1');
const querystring = require('querystring') 
var FirebaseService = { 
    firebaseAuth($data) { 
        return new Promise(function(resolve,reject) { 
        var $options= {}; 
        $options.method='get' 
        if($data) { 
            $options.url='authenticateFirebase?'+ querystring.stringify($data) 
        } 
        ApiService.request($options) 
            .then(response => {  
                resolve(response.data) 
            }).catch(error=> { 
                reject(error);
            }) 
        });
    },
    async getAuthInfo($token) {
        var $options= {}; 
        $options.method='post'
        $options.url = 'authInfo'
        $options.data = {"token":$token}
        let $response= await ApiService.request($options)
        return Promise.resolve($response.data.data)
    }        
}; 
export default FirebaseService;